import { getImproveAreasForExportByAreaIds } from "../../../API/Improve/Improve";
import { ImproveAreaExportData } from "./types";

export async function fetchImproveExportData(
  areaIds: string[],
  options?: { archived?: boolean }
): Promise<ImproveAreaExportData[]> {
  const unique = Array.from(new Set(areaIds.filter(Boolean)));
  if (unique.length === 0) {
    return [];
  }

  const items = await getImproveAreasForExportByAreaIds(
    unique,
    options?.archived ?? false
  );

  const byId = new Map(items.map((x) => [x.areaId, x]));
  const ordered: ImproveAreaExportData[] = [];
  for (const id of unique) {
    const item = byId.get(id);
    if (item) ordered.push(item);
  }
  for (const item of items) {
    if (!unique.includes(item.areaId)) {
      ordered.push(item);
    }
  }
  return ordered;
}
